var _defs, _rect, _rect2, _rect3, _rect4, _g, _g2, _path, _rect5, _polyline, _path2, _circle, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatellite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 259.05 233.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #66c2e0;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke: #68627d;\n      }\n\n      .cls-2, .cls-8 {\n        fill: #ffcba4;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n      }\n\n      .cls-9, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #1983e3;\n      }\n\n      .cls-5 {\n        fill: #ff7d1b;\n      }\n\n      .cls-7 {\n        fill: #29abe2;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.2,
    y: 156.41,
    width: 22.02,
    height: 16.9,
    transform: "translate(272.05 206.16) rotate(131.14)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 132.99,
    y: 132.24,
    width: 36.86,
    height: 9.22,
    transform: "translate(127.43 -65.83) rotate(41.14)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 93.74,
    width: 36.86,
    height: 9.22,
    transform: "translate(91.21 -46.34) rotate(41.14)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 104.99,
    y: 59.99,
    width: 49.29,
    height: 115.98,
    rx: 11.86,
    ry: 11.86,
    transform: "translate(149.63 292.11) rotate(-138.86)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 139.25,
    y: 159.56,
    width: 128.67,
    height: 46.01,
    rx: 23,
    ry: 23,
    transform: "translate(236.77 453.98) rotate(-138.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.25,222.35l-96.9-84.66s13.28-14.43,27.58-1.99c14.3,12.44,65.06,56.6,65.06,56.6,0,0,16,10.84,4.26,30.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.41,
    y: 195.5,
    width: 45.93,
    height: 18.94,
    transform: "translate(-75.89 242.84) rotate(-48.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 180.23,
    y: 172.71,
    width: 45.93,
    height: 18.94,
    transform: "translate(-67.69 215.33) rotate(-48.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 153.99,
    y: 149.75,
    width: 45.93,
    height: 18.94,
    transform: "translate(-59.38 187.72) rotate(-48.86)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -9.71,
    y: 29.41,
    width: 128.67,
    height: 46.01,
    rx: 23,
    ry: 23,
    transform: "translate(61.28 127.83) rotate(-138.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.3,92.21L8.4,7.55s13.28-14.43,27.58-1.99c14.3,12.44,65.06,56.6,65.06,56.6,0,0,16,10.84,4.26,30.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.46,
    y: 65.35,
    width: 45.93,
    height: 18.94,
    transform: "translate(-28.84 86.16) rotate(-48.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 31.28,
    y: 42.57,
    width: 45.93,
    height: 18.94,
    transform: "translate(-20.64 58.65) rotate(-48.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.04,
    y: 19.61,
    width: 45.93,
    height: 18.94,
    transform: "translate(-12.32 31.04) rotate(-48.86)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M194.49,73.9c4.39-5.28,6.09-12.61,3.88-19.65-3.46-11.01-15.19-17.14-26.21-13.68-3.67,1.15-6.8,3.23-9.21,5.89l31.54,27.44Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 151.96,
    y: 60.5,
    width: 42.36,
    height: 13.31,
    rx: 6.59,
    ry: 6.59,
    transform: "translate(86.94 -97.34) rotate(41.14)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "49.2 184.75 47.33 217.3 65.43 195.16 77.15 208.84 50.31 219.44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.15,222.46c8.03-9.86,11.03-23.47,6.8-36.46-6.63-20.32-28.47-31.43-48.8-24.81-6.78,2.21-12.53,6.11-16.95,11.09l58.94,50.18Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 47.66,
    cy: 217.46,
    r: 5.89
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.94,
    y: 79.09,
    width: 38.91,
    height: 16.9,
    rx: 8.45,
    ry: 8.45,
    transform: "translate(96.22 -81.28) rotate(41.14)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.72,
    y: 94.48,
    width: 38.91,
    height: 16.9,
    rx: 8.45,
    ry: 8.45,
    transform: "translate(103.08 -68.79) rotate(41.14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite.5b76ebb65cb6f504acd00392962b4045.svg";
export { ForwardRef as ReactComponent };